import { fas } from "@fortawesome/free-solid-svg-icons"


export const getPanChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "PAN" && dataAutomationData.PAN === true) {
        return true
    } else {
        return false
    }
}

export const getGstFilingChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "GST_FILING" && dataAutomationData.GST_FILING === true) {
        return true
    } else {
        return false
    }
}

export const getBankChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "BANK" && dataAutomationData.BANK === true) {
        return true
    } else {
        return false
    }
}



export const getVehicleNumberChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "VEHICLE_NUMBER" && dataAutomationData.VEHICLE_NUMBER === true) {
        return true
    } else {
        return false
    }
}


export const getEmailIdChecks = (dataAutomationData, dataVariable) => {
  return dataVariable === "EMAIL" && dataAutomationData.EMAIL === true;
}

export const getChallanChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "CHALLAN" && dataAutomationData.CHALLAN === true) {
        return true
    } else {
        return false
    }
}

export const getTanChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "TAN" && dataAutomationData.TAN === true) {
        return true
    } else {
        return false
    }
}

export const getKybChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "KYB" && dataAutomationData.KYB === true) {
        return true
    } else {
        return false
    }
}


export const getFSSAIChecks = (dataAutomationData, dataVariable) => {
    if (dataVariable === "FSSAI_CERTIFICATE" && dataAutomationData.FSSAI_CERTIFICATE === true) {
        return true
    } else {
        return false
    }
}

export const getStatusCheck = (dataVariable, crawlerData) => {
    if(crawlerData.length > 0){
        for (let i = 0; i < crawlerData.length; i++) {
            if (crawlerData[i].crawlerName === dataVariable) {
                return crawlerData[i].crawlerStatus;
            }
        }    
    } else {
        return "";
    }
}

export const getFailureReason = (dataVariable, crawlerData) => {
    if(crawlerData.length > 0){
        for (let i = 0; i < crawlerData.length; i++) {
            if (crawlerData[i].crawlerName === dataVariable) {
                return crawlerData[i].failureReason;
            }
        }    
    } else {
        return "";
    }
}